export default __webpack_public_path__ + "static/python-front-end-web-c8a398c410379fd8f8234a238d5b205e.webp";